
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/test-series",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/test-series.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/test-series"])
      });
    }
  